<template>
    <div v-if="is_responsive" class="table-responsive">
        <table class="table" :class="_class">
            <slot></slot>
        </table>
    </div>
    <table v-else class="table" :class="_class">
        <slot></slot>
    </table>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default: function() {
                return []
            }
        },
        is_responsive: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        _class: function() {
            let _class = []

            this.options.forEach(option => {
                _class.push('table-'+option)    
            });

            return _class
        }
    }
}
</script>